var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcunit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16663 17.3334V13.875L5.45829 16.5417L4.29163 15.375L8.16663 11.5V9.83335H6.49996L2.62496 13.7084L1.45829 12.5417L4.12496 9.83335H0.666626V8.16669H4.12496L1.45829 5.45835L2.62496 4.29169L6.49996 8.16669H8.16663V6.50002L4.29163 2.62502L5.45829 1.45835L8.16663 4.12502V0.666687H9.83329V4.12502L12.5416 1.45835L13.7083 2.62502L9.83329 6.50002V8.16669H11.5L15.375 4.29169L16.5416 5.45835L13.875 8.16669H17.3333V9.83335H13.875L16.5416 12.5417L15.375 13.7084L11.5 9.83335H9.83329V11.5L13.7083 15.375L12.5416 16.5417L9.83329 13.875V17.3334H8.16663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcunit);
export default __webpack_public_path__ + "static/media/acunit.0cdd423b7df6007a8d72c9d9e3676505.svg";
export { ForwardRef as ReactComponent };